import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, signInAnonymously, linkWithPopup } from 'firebase/auth';

// Firebase web config is read from window.__APP_CONFIG__.FIREBASE_CONFIG —
// an object injected at container start by inject-config.sh from the
// FIREBASE_CONFIG env var (which Cloud Run mounts from Secret Manager).
// Local dev (npm run dev) falls back to Vite's import.meta.env, populated
// from frontend/.env.local — see frontend/.env.example.
//
// All Firebase web config values are PUBLIC; they ship to every browser.
// Security comes from Auth/Firestore rules, not from key obscurity.

const runtimeFirebase = (window as any).__APP_CONFIG__?.FIREBASE_CONFIG || {};

const firebaseConfig = {
  apiKey: runtimeFirebase.apiKey || import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: runtimeFirebase.authDomain || import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: runtimeFirebase.projectId || import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: runtimeFirebase.storageBucket || import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: runtimeFirebase.messagingSenderId || import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: runtimeFirebase.appId || import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: runtimeFirebase.measurementId || import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.apiKey) {
  console.error(
    'Firebase config is missing. For local dev, copy frontend/.env.example to .env.local. ' +
    'For deployed environments, ensure the firebase-config-{env} Secret Manager secret exists ' +
    'and is mounted into the frontend service (see infrastructure/BOOTSTRAP.md).'
  );
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup, signOut, signInAnonymously, linkWithPopup };
